import { Pipe, PipeTransform } from '@angular/core';
import { getActivityFooterText } from './activity.functions';

@Pipe({
  name: 'activityFooterText'
})
export class ActivityFooterTextPipe implements PipeTransform {
    transform(activity, showProject): string {
        return getActivityFooterText(activity, showProject);
    }
};